<script setup>
  import { ref, computed, onBeforeMount } from "vue";
  import { useCompanyStore } from "@/stores/company";
  import { useUiStore } from "@/stores/ui";
  import { useDevicesStore } from "@/stores/devices";

  const emit = defineEmits(['refresh']);
  const uiStore = useUiStore();
  const devicesStore = useDevicesStore();
  let name = ref(null);
  let id = ref(null);
  let isSubmitted = ref(false);  
  let devicesNames = ref([]);
  let devicesIds = ref([]);
  
  const getModalInfo = computed(() => uiStore.modalData);
  const getModalAction = computed(() => uiStore.modalAction);
  const companyId = useCompanyStore().companyId;

  const onSubmit = () => {
    isSubmitted.value = true;
    let data = {};
    let action = '';
    if(getModalAction.value == 'deregister_device'){
      action = 'deregisterDevice';
      data = { 
        id : id.value, 
        companyId : companyId
      }

    }else if(getModalAction.value == 'mass_deregister_devices') {
      action = 'massDeregisterDevices';
      data = { 
        companyId : companyId,
        body : {
          devices : devicesIds.value,
          _method : 'DELETE',
        },

      }
    }
    devicesStore[action](data)
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });
  };

  const resetStoreData = () =>{
    uiStore.resetModalStore();
  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalInfo.value.data_type == 'device' && getModalAction.value == 'deregister_device'){
      name.value = getModalInfo.value.name;
      id.value = getModalInfo.value.id;
    }else if(getModalAction.value == 'mass_deregister_devices') {
      if(Array.isArray(getModalInfo.value)){
        getModalInfo.value.map((row) =>{
          devicesNames.value.push(row.name)
          devicesIds.value.push(row.id)
        });
        name.value = devicesNames.value.join(", ");
      }
    }
  });
</script>

<template>
  <DModal v-if="['deregister_device', 'mass_deregister_devices'].includes(getModalAction)" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> De-register Device </template>

    <template #body>
      <div class="delete-text mb-3">
        <span v-if="getModalAction == 'deregister_device'">Are you sure you want to  <b>"De-register"</b> the device "{{ name }}" ?</span>
        <span v-if="getModalAction == 'mass_deregister_devices'">Are you sure you want to  <b>"De-register"</b> the devices "{{ name }}" ?</span>
      </div>
      <p class="delete-text">De-registering a device will delete all data stored on it.</p>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button @click="resetStoreData" type="button" class="btn btn-primary add-button mr-30">Cancel</button>
          <button :disabled="isSubmitted" @click="onSubmit" type="button" class="btn btn-secondary cancel-button" >
            De-register <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
